export const PaymentDetailsEnum = {
  lookupTypeName: 'Banks',
};
